import { CreateImageCloud, ImageCloud, OrderFilter, PagingResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _ImageCloudService {
  public getImageCloud(
    tab?: string,
    page?: number,
    filter: OrderFilter & { state?: "active" | "ended" | "" } = {},
    /** gọi nền (tự cập nhật): không hiện loader / toast */
    silent = false
  ) {
    return HttpService.get<PagingResponse<ImageCloud>>("/image-cloud", {
      silent,
      queryParams: {
        tab,
        page,
        ...filter,
      },
    });
  }

  public createImageCloud(createImageRequest: CreateImageCloud) {
    return HttpService.post<any>("/image-cloud", {
      body: {
        ...createImageRequest,
      },
    });
  }

  public deleteImageCloud(imageId: string) {
    return HttpService.delete<any>(`/image-cloud/${imageId}`);
  }

  public getCloudRdpFile(image_id: string) {
    return HttpService.requestDownload("/image-cloud/connect-pc/" + image_id);
  }

  public startImage(imageId: string) {
    return HttpService.get<any>(`/image-cloud/start/${imageId}`);
  }

  public leaveQueue(imageId: string) {
    return HttpService.get<any>(`/image-cloud/leave-queue/${imageId}`);
  }

  public reStartImage(imageId: string) {
    return HttpService.get<any>(`/image-cloud/restart-vm/${imageId}`);
  }

  public deleteImageVM(imageId: string) {
    return HttpService.get<any>(`/image-cloud/delete-vm/${imageId}`);
  }

  public backupImageVM(imageId: string) {
    return HttpService.get<any>(`/image-cloud/backup-vm/${imageId}`);
  }

  public restoreImageVM(imageId: string) {
    return HttpService.get<any>(`/image-cloud/restore-vm/${imageId}`);
  }

  public shutdownImageVM(imageId: string) {
    return HttpService.get<any>(`/image-cloud/shutdown-vm/${imageId}`);
  }

  /** times: số lần gia hạn trong 1 lượt (1–6), API mặc định 1 */
  public extendsImageVM(imageId: string, times = 1) {
    return HttpService.get<any>(`/image-cloud/extend-vm/${imageId}`, {
      queryParams: { times },
    });
  }

  public addHarware(imageId: string, hardwaresListId: string[]) {
    return HttpService.post<any>(`/image-cloud/add-hardwares/${imageId}`, {
      body: { hardwaresListId },
    });
  }

  // public wol(imageId: string) {
  //   return HttpService.get<any>(`/images/wol/${imageId}`);
  // }

  // public reConnect(imageId: string) {
  //   return HttpService.get<any>(`/images/reconnect/${imageId}`);
  // }
}

const ImageCloudService = new _ImageCloudService();

export default ImageCloudService;
